import { render } from "./UserRoles.vue?vue&type=template&id=8593be86"
import script from "./UserRoles.vue?vue&type=script&lang=js"
export * from "./UserRoles.vue?vue&type=script&lang=js"

import "./UserRoles.vue?vue&type=style&index=0&id=8593be86&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__